module.exports = __webpack_public_path__ + "img/plan-2-b12.e53048af.png";